/* eslint-disable */
var $ = window.jQuery = require('jquery');
import {
  bus
} from '../../main';
import toast from '../../services/toast';
import axios from 'axios';
export default {
  name: 'user-search-filter',
  components: {},
  props: [],
  data () {
    return {
      submitted:false,
      isSearchOpen :false,
      searchData: '',
      userSearch:'',
      userSearchList:'',
      userFilterInput:''
    }
  },
  computed: {

  },
  mounted () {
    var _self = this
    $(document).click(function(event) {
      if (!$(event.target).closest(".user_search_field, .autocomplete-userresults").length) {
        _self.isSearchOpen = false;
        $('.autocomplete-userresults').addClass("d-none")
        $('.httploader').removeClass("searchLoaderhide")
        $('.routeloader').removeClass("searchLoaderhide")
      }
    });
  },
  methods: {
    userSearchOnChange(){
      $('.user_search').addClass("show_search")
      if(this.userSearch.length >= 3){
       $('.httploader').addClass("searchLoaderhide")
        $('.routeloader').addClass("searchLoaderhide")
        this.isSearchOpen = true;
        if (this.userSearch) {
          this.submitted = true;
          axios.get('/account/admin/users/?name=' + this.userSearch)
            .then((response) => {
              if (response.status == '200') {
                this.userSearchList = response.data.data.results
                this.$validator.reset()
              }
            })
            .catch((err) => {})
        }
      }else{
        this.isSearchOpen = false;
      }
    },
    validateSearchUserBeforeSubmit() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.searchData = this.userSearch
          if (this.searchData) {
            this.submitted = true;
            axios.get('/account/admin/users/?name=' + this.searchData)
              .then((response) => {
                if (response.status == '200') {                  
                  bus.$emit('ShowUserSearchResults', response.data.data.results);
                  this.$validator.reset()
                }
              })
              .catch((err) => {})
          }
        }
      })
    },
  }
}